@if (topics().length > 0) {
  <div class="tags flex flex-wrap gap-2">
    @for (topic of topics(); track topic.id) {
      <span
        class="h-[22px] cursor-default whitespace-nowrap rounded-[6px] px-1.5 py-0.5 text-xs font-semibold transition-colors"
        [class.bg-sky-100]="topic.isSelected"
        [class.text-sky-600]="topic.isSelected"
        [class.bg-neutral-100]="!topic.isSelected"
        [class.text-neutral-600]="!topic.isSelected"
        [matTooltip]="topic.name"
        [matTooltipPosition]="'above'"
      >
        {{ topic.code }}
      </span>
    }
  </div>
}
